import React, { memo } from "react";
import iconFilter from "../../img/icons/filter.png";
import { observer } from "mobx-react-lite";
import Memory from "../../api/Memory";
import { useOptionalCompanyPrintLabelStatsContext } from "./card/CompanyPrintLabelStatsContext";
import { formatEventTotalDisplay } from "../../utils/eventTotalsSaUtils";

const formatSiteField = (value) => {
  if (value === null || value === undefined || value === "") {
    return { text: "не заполнено", muted: true };
  }
  return { text: value, muted: false };
};

function SitePrintLabelSkeleton() {
  return (
    <div
      className="site-print-label-skeleton"
      aria-busy="true"
      aria-label="Загрузка статистики печати"
    >
      <div className="event-totals-skeleton-chip site-print-label-skeleton-line" />
      <div className="event-totals-skeleton-chip site-print-label-skeleton-line" />
      <div className="event-totals-skeleton-chip site-print-label-skeleton-line site-print-label-skeleton-line--short" />
    </div>
  );
}

const ItemProduction = observer((props) => {
  const printStats = useOptionalCompanyPrintLabelStatsContext();
  const address = formatSiteField(props.itemproduction.address_production);
  const contact = formatSiteField(props.itemproduction.contact_representative);
  const phone = formatSiteField(props.itemproduction.phone);
  const isFilterActive =
    Memory.var_filter_by_production === props.itemproduction.name_production;

  const handleFilterClick = (e) => {
    e.stopPropagation();
    props.getSoftProductionFunc(props.itemproduction);
  };

  const showPrintBlock = Boolean(printStats?.canView);
  const printLoading = printStats?.loading;
  const printError = printStats?.error;
  const printLabels =
    showPrintBlock && !printLoading && !printError && printStats
      ? printStats.getLabelsForProduction(props.itemproduction.id)
      : [];
  const printTotal = printLabels.reduce(
    (sum, row) => sum + (Number(row.count) || 0),
    0,
  );
  const hasPrintContent =
    showPrintBlock &&
    (printLoading || (!printError && printLabels.length > 0));

  return (
    <article
      className={
        isFilterActive ? "site-item site-item--filter-active" : "site-item"
      }
      onClick={() => props.moveSoftProductionFunc(props.itemproduction)}
    >
      <div className="site-item-header">
        <span className="site-item-name">
          {props.itemproduction.name_production}
        </span>
        <img
          className="icon-filter-btn item-production-filter-img"
          onClick={handleFilterClick}
          src={iconFilter}
          alt="Фильтровать софт по этой площадке"
          title="Фильтровать софт по этой площадке"
        />
      </div>
      <div className="site-item-details">
        <div className="site-detail-line">
          <span className="detail-label">Адрес:</span>
          <span
            className={
              address.muted ? "detail-value detail-value-muted" : "detail-value"
            }
          >
            {address.text}
          </span>
        </div>
        <div className="site-detail-line">
          <span className="detail-label">ФИО:</span>
          <span
            className={
              contact.muted ? "detail-value detail-value-muted" : "detail-value"
            }
          >
            {contact.text}
          </span>
        </div>
        <div className="site-detail-line">
          <span className="detail-label">Телефон:</span>
          <span
            className={
              phone.muted ? "detail-value detail-value-muted" : "detail-value"
            }
          >
            {phone.text}
          </span>
        </div>
        {hasPrintContent ? (
          <div className="site-print-label-stats">
            {printLoading ? (
              <>
                <div className="site-detail-line site-print-label-stats-heading">
                  <span className="detail-label">Напечатано:</span>
                </div>
                <SitePrintLabelSkeleton />
              </>
            ) : (
              <div className="site-detail-line site-print-label-line site-print-label-line--summary">
                <span className="detail-label">Напечатано:</span>
                <span className="detail-value">
                  {formatEventTotalDisplay(printTotal)} шт
                </span>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </article>
  );
});

export default memo(ItemProduction);
